import Authorization from './Authorization';

export default [{
  exact: false,
  path: '/data-sources/',
  component: Authorization,
}];



// WEBPACK FOOTER //
// ./src/components/common/authorization/routes.js